import React from 'react';

import {PartnerMachinesGrid} from './PartnerMachinesGrid';
import './PartnerMachines.style.scss';

export const PartnerMachines = React.memo(() => {
  return (
    <div className="machines" id="maquininhas">
      <h2 className="machines__title">Nossos parceiros</h2>
      <h3 className="machines__sub-title">
        Conheça todas as maquininhas que aceitam cartões Alelo!
      </h3>
      <p className="machines__text">
        Antes de se credenciar conosco, não se esqueça de já ter pelo menos uma
        das maquininhas abaixo contratadas para o seu estabelecimento.
      </p>
      <PartnerMachinesGrid className="machines__grid" />
    </div>
  );
});
